import { render, staticRenderFns } from "./pre-compras.vue?vue&type=template&id=ad825c78&scoped=true"
import script from "./pre-compras.vue?vue&type=script&lang=js"
export * from "./pre-compras.vue?vue&type=script&lang=js"
import style0 from "./pre-compras.vue?vue&type=style&index=0&id=ad825c78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad825c78",
  null
  
)

export default component.exports